import { LostAndFoundItem } from '@/types/community/lostAndFound';

// Helper function to get dates relative to current date
function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}

export const lostAndFoundItems: LostAndFoundItem[] = [
  // Recent items (last few days)
  {
    id: 'LF001',
    title: 'Reloj de Oro',
    description: 'Reloj chapado en oro con correa de cuero',
    category: 'jewelry',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-1, 15, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Acompañante de Piscina',
      type: 'employee'
    },
    photos: [
      {
        id: 'PHO001',
        name: 'watch_photo.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/images/lostAndFound/LF001/watch_photo.jpg',
        url: 'https://example.com/photos/watch1.jpg',
        uploadedAt: getRelativeDate(-1, 15, 0)
      }
    ],
    value: {
      amount: 500,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF002',
    title: 'iPhone 13',
    description: 'iPhone 13 negro con pantalla rota',
    category: 'electronics',
    status: 'claimed',
           condition: 'poor',
    foundAt: getRelativeDate(-2, 10, 0),
    returnedAt: getRelativeDate(-1, 14, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES001',
      name: 'Juan Pérez',
      type: 'resident'
    },
    handedOverTo: {
      id: 'EMP001',
      name: 'Gerente Comunitario'
    },
    value: {
      amount: 800,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF003',
    title: 'Llaves de Auto',
    description: 'Juego de llaves de auto con control remoto',
    category: 'other',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-3, 8, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF004',
    title: 'Billetera',
    description: 'Billetera de cuero marrón con tarjetas de crédito',
    category: 'other',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-4, 16, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Acompañante de Piscina',
      type: 'employee'
    },
    value: {
      amount: 50,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF005',
    title: 'Gafas de Sol',
    description: 'Gafas de sol Ray-Ban aviador',
    category: 'clothing',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-5, 12, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    value: {
      amount: 200,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Past week items
  {
    id: 'LF006',
    title: 'Paraguas',
    description: 'Paraguas negro con mango de madera',
    category: 'clothing',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-6, 9, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF007',
    title: 'Cargador de Laptop',
    description: 'Cargador de MacBook Pro con cable',
    category: 'electronics',
    status: 'claimed',
    condition: 'good',
    foundAt: getRelativeDate(-7, 11, 0),
    returnedAt: getRelativeDate(-6, 15, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Acompañante de Piscina',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES002',
      name: 'Ana García',
      type: 'resident'
    },
    value: {
      amount: 80,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF008',
    title: 'Mochila',
    description: 'Mochila escolar azul con libros',
    category: 'other',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-8, 14, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF009',
    title: 'Aretes',
    description: 'Aretes de perno de plata',
    category: 'jewelry',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-9, 17, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento',
      type: 'employee'
    },
    value: {
      amount: 30,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF010',
    title: 'Botella de Agua',
    description: 'Botella de agua de acero inoxidable',
    category: 'other',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-10, 13, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Acompañante de Piscina',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Past month items
  {
    id: 'LF011',
    title: 'Anillo de Diamante',
    description: 'Anillo de diamante de oro blanco',
    category: 'jewelry',
    status: 'claimed',
    condition: 'good',
    foundAt: getRelativeDate(-15, 10, 0),
    returnedAt: getRelativeDate(-14, 16, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES003',
      name: 'Sara Wilson',
      type: 'resident'
    },
    value: {
      amount: 2500,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF012',
    title: 'iPad Pro',
    description: 'iPad Pro de 12.9 pulgadas con Apple Pencil',
    category: 'electronics',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-18, 9, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento',
      type: 'employee'
    },
    value: {
      amount: 1200,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF013',
    title: 'Zapatillas de Running',
    description: 'Zapatillas Nike de running talla 10',
    category: 'clothing',
    status: 'found',
    condition: 'fair',
    foundAt: getRelativeDate(-20, 7, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Acompañante de Piscina',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF014',
    title: 'Pasaporte',
    description: 'Pasaporte estadounidense en buen estado',
    category: 'documents',
    status: 'claimed',
    condition: 'good',
    foundAt: getRelativeDate(-22, 14, 0),
    returnedAt: getRelativeDate(-21, 10, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES004',
      name: 'Miguel Johnson',
      type: 'resident'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF015',
    title: 'Bolsa de Gimnasio',
    description: 'Bolsa de gimnasio negra con ropa de entrenamiento',
    category: 'other',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-25, 18, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Older items
  {
    id: 'LF016',
    title: 'Bicicleta',
    description: 'Bicicleta de montaña con casco',
    category: 'other',
    status: 'claimed',
    condition: 'good',
    foundAt: getRelativeDate(-30, 8, 0),
    returnedAt: getRelativeDate(-28, 15, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Acompañante de Piscina',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES005',
      name: 'David Brown',
      type: 'resident'
    },
    value: {
      amount: 400,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF017',
    title: 'Laptop',
    description: 'Laptop Dell XPS 13',
    category: 'electronics',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-35, 11, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    value: {
      amount: 1500,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF018',
    title: 'Raqueta de Tenis',
    description: 'Raqueta de tenis Wilson con estuche',
    category: 'other',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-40, 16, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF019',
    title: 'Tarjeta de Crédito',
    description: 'Tarjeta de crédito Visa',
    category: 'documents',
    status: 'disposed',
    condition: 'good',
    foundAt: getRelativeDate(-45, 12, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Acompañante de Piscina',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF020',
    title: 'Funda de Teléfono',
    description: 'Funda para iPhone 14 Pro',
    category: 'electronics',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-50, 10, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 